
import { useState } from 'react';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setMessage('الرجاء إدخال البريد الإلكتروني');
      return;
    }

    setIsSubmitting(true);
    setMessage('');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d4m20ua32n60g3bh80k0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setMessage('شكراً لاشتراكك! سنرسل لك أحدث العروض والمنتجات.');
        setEmail('');
      } else {
        setMessage('حدث خطأ، الرجاء المحاولة مرة أخرى');
      }
    } catch (error) {
      setMessage('حدث خطأ، الرجاء المحاولة مرة أخرى');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-rose-100 to-rose-50" dir="rtl">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-rose-400 rounded-full mx-auto mb-6">
            <i className="ri-mail-line text-3xl text-white"></i>
          </div>
          
          <h2 className="text-4xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            اشتركي في نشرتنا البريدية
          </h2>
          <p className="text-gray-600 mb-8 text-lg">
            احصلي على أحدث العروض والمنتجات الحصرية مباشرة في بريدك الإلكتروني
          </p>

          <form 
            id="newsletter-form"
            data-readdy-form
            onSubmit={handleSubmit}
            className="max-w-xl mx-auto"
          >
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="أدخلي بريدك الإلكتروني"
                className="flex-1 px-6 py-4 rounded-full border-2 border-white bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:border-rose-300 transition-colors text-sm"
                required
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="px-10 py-4 bg-rose-400 text-white rounded-full font-medium hover:bg-rose-500 transition-colors shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'جاري الإرسال...' : 'اشتركي الآن'}
              </button>
            </div>
            
            {message && (
              <p className={`mt-4 text-sm ${message.includes('شكراً') ? 'text-emerald-600' : 'text-red-500'}`}>
                {message}
              </p>
            )}
          </form>

          <p className="text-xs text-gray-500 mt-6">
            بالاشتراك، أنت توافقين على سياسة الخصوصية الخاصة بنا
          </p>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
